import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  NbMediaBreakpointsService,
  NbMenuService,
  NbSidebarService,
  NbThemeService,
} from '@nebular/theme';
import { NgxAuthService } from 'app/modules/auth/services/ngx-auth.service';
import { Profile } from 'app/services/profile.service';
import { User } from 'models/user';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { LayoutService } from '../../../@core/utils';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: User;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [{ title: 'Profile' }, { title: 'Log out' }];

  constructor(
    private sidebarService: NbSidebarService,
    private auth_service: NgxAuthService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private profile: Profile,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private nb_menu_service: NbMenuService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    this.profile.Me().then((user) => (this.user = user));
    this.setupUserMenu();

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe(
        (isLessThanXl: boolean) => (this.userPictureOnly = isLessThanXl),
      );

    this.themeService
      .onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe((themeName) => (this.currentTheme = themeName));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  setupUserMenu() {
    this.nb_menu_service
      .onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'header-user-options'),
        map(({ item: { title } }) => title),
      )
      .subscribe((title) => {
        if (title === 'Log out') return this.logout();
        else if (title === 'Profile') return this.goToProfile();
      });
  }

  logout() {
    this.auth_service.logout();
  }

  goToProfile() {
    this.router.navigate(['/users/me']);
  }
}
